export default "__VITE_ASSET__f0584a4c__"